var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticStyle:{"width":"100%","height":"84vh","border":"0","padding-top":"10px"},attrs:{"src":_vm.workflowUrl}})}
var staticRenderFns = []

export { render, staticRenderFns }